import { Account } from '../../../../models/account'

export type AdminManageClerkInfoPaneProps = {
	clerk: Account
}
export const AdminManageClerkInfoPane = (props: AdminManageClerkInfoPaneProps) => {
	return (
		<div className="flex flex-row flex-grow w-full">
			<div className='grid w-1/2 grid-cols-2 grid-rows-2 border-r border-[#B3C2E1] gap-y-8 ml-10'>
				<div>
					<p className='mb-2 text-sm font-medium text-gray-400 uppercase'>First Name</p>
					<p>{props.clerk.firstName}</p>
				</div>
				<div>
					<p className='mb-2 text-sm font-medium text-gray-400 uppercase'>Last Name</p>
					<p>{props.clerk.lastName}</p>
				</div>
				<div>
					<p className='mb-2 text-sm font-medium text-gray-400 uppercase'>Email</p>
					<p>{props.clerk.email}</p>
				</div>
				<div>
					<p className='mb-2 text-sm font-medium text-gray-400 uppercase'>Phone Number</p>
					<p>{props.clerk.phone}</p>
				</div>
			</div>
			<div className='grid w-1/2 grid-cols-2 grid-rows-2 ml-10 gap-y-8'>
				<div>
					<p className='mb-2 text-sm font-medium text-gray-400 uppercase'>County</p>
					<p>{props.clerk.county}</p>
				</div>
				<div className='grid-rows-span-2'>
					<p className='mb-2 text-sm font-medium text-gray-400 uppercase'>Address</p>
					<p>{props.clerk.address1}</p>
					<p>{props.clerk.address2}</p>
					<p>{props.clerk.city}, {props.clerk?.state?.abbv} {props.clerk.postalCode}</p>
				</div>
				<div>
					<p className='mb-2 text-sm font-medium text-gray-400 uppercase'>Municipality</p>
					<p>{props.clerk.municipality}</p>
				</div>
			</div>
		</div>
	)
}
